import { ADAPTERS } from '@enums';

const { TYPES: ADAPTER_TYPES } = ADAPTERS;

export const excludedAdapters = [ADAPTER_TYPES.CODAT.value, ADAPTER_TYPES.JSON_CODAT.value];
